import React, { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import {
  Container,
  Row,
  Col,
  Button,
  ButtonGroup,
  Spinner,
} from 'reactstrap'
//import 'pdfjs-dist/web/pdf_viewer.css'
import 'bootstrap/dist/css/bootstrap.min.css'


const PdfViewer = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [loading, setLoading] = useState(true)

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
    setPageNumber(1)
    setLoading(false)
  }

  const goToPrev = () => setPageNumber((prev) => Math.max(prev - 1, 1))
  const goToNext = () => setPageNumber((prev) => Math.min(prev + 1, numPages))

  return (
    <Container fluid className="p-0">
      <Row className="justify-content-center mb-3">
        <Col xs="auto">
          <ButtonGroup>
            <Button color="primary" onClick={goToPrev} disabled={pageNumber <= 1}>
              ◀ Prev
            </Button>
            <Button disabled color="light">
              Page {pageNumber} of {numPages || '...'}
            </Button>
            <Button color="primary" onClick={goToNext} disabled={pageNumber >= numPages}>
              Next ▶
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      <Row className="justify-content-center p-0">
        <Col xs="auto" style={{ border: '1px solid #dee2e6', padding: '1px', borderRadius: '8px' }}>
          {loading && (
            <div className="text-center mb-3">
              <Spinner color="primary" />
            </div>
          )}
          <div
            style={{
              overflowX: 'auto',
              maxWidth: '100vw',
            }}
          >
            <Document
              file={fileUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadStart={() => setLoading(true)}
              loading={<Spinner color="primary" />}
              error={<p className="text-danger">Failed to load PDF</p>}
            >
              <Page
                pageNumber={pageNumber}
                renderMode="canvas"
              />
            </Document>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default PdfViewer
